import React from 'react'

export const redirectTo = (x) => {
  //if (__DEV__) console.log("redirect:", x)
  window.location.replace(
    window.location.pathname + window.location.search + x
  );
}

// redirect to path if predicate returns true
export function redirect (path, predicate) {
  return Component =>
    class Composed extends React.Component {

      componentWillMount () {
        if (predicate(this.props))
          redirectTo(path)
      }

      componentWillReceiveProps (nextProps) {
        if (predicate(nextProps))
          redirectTo(path)
      }

      render () {
        return <Component {...this.props} />
      }
    }
}

//redirect to path if submitted
export function redirectSubmitted (path) {
  return redirect(path, ({ submitted }) => submitted)
}




// WEBPACK FOOTER //
// ./src/app/redirect.js